import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ModalTrigger from '../common/ModalTrigger';
import { putRequest } from '../../requestUtils';

class SubmitToEmployer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      text: props.advisorRemark,
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  buildSubmitOnBehalfStr() {
    const { resubmit } = this.props;
    return `${resubmit ? 'Resubmit' : 'Submit'} to Employer`;
  }

  buildSubmitOnBehalfWarning() {
    const { onBehalf, resubmit } = this.props;
    return `Are you sure you want to ${resubmit ? 'resubmit' : 'submit'} this proposal to the employer${onBehalf ? ' on behalf of the consultant' : ''}? ${onBehalf ? 'The consultant has not yet had a chance to review and submit on their own.' : ''}`;
  }

  handleInputChange(event) {
    const { target } = event;
    const { value } = target;
    const { name } = target;
    this.setState({
      [name]: value,
    });
  }

  handleSubmit() {
    const {
      formUrl, csrfToken, handleProposalAfterSubmit, showNewProposalUX,
    } = this.props;
    const data = this.state;

    return putRequest(
      formUrl,
      data,
      csrfToken,
    ).then((res) => {
      if (showNewProposalUX) {
        handleProposalAfterSubmit(res.data);
      } else {
        window.location.reload();
      }
    }).catch((err) => {
      this.setState({ errors: err });
    });
  }

  render() {
    const { submitButtonText, triggerType, buttonStyles } = this.props;
    const { text } = this.state;
    return (
      <ModalTrigger
        triggerText={this.buildSubmitOnBehalfStr()}
        buttonStyles={buttonStyles}
        submitButtonText={submitButtonText}
        handleSubmit={this.handleSubmit}
        headerTitle={<strong>Confirm proposal submission</strong>}
        triggerType={triggerType}
        idKey="submit-to-employer"
        cloneContent={false}
        closeAfterSubmit
      >
        <p>{this.buildSubmitOnBehalfWarning()}</p>
        <div><strong>Reminder: check if the Consultant Referral Agreement was signed</strong></div>
        <div className="mt-12 mb-12">Remarks about the consultant for the employer:</div>
        <textarea
          value={text || ''}
          className="form-control"
          placeholder="Consultant is a ..."
          name="text"
          id="text"
          rows="4"
          onChange={this.handleInputChange}
        />
      </ModalTrigger>
    );
  }
}

SubmitToEmployer.propTypes = {
  formUrl: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  submitButtonText: PropTypes.string,
  triggerType: PropTypes.string,
  resubmit: PropTypes.bool,
  onBehalf: PropTypes.bool,
  advisorRemark: PropTypes.string,
  buttonStyles: PropTypes.string,
  handleProposalAfterSubmit: PropTypes.func,
  showNewProposalUX: PropTypes.bool,
};

SubmitToEmployer.defaultProps = {
  submitButtonText: 'Yes, submit',
  triggerType: 'button',
  resubmit: false,
  onBehalf: false,
  advisorRemark: '',
  buttonStyles: 'danger',
  handleProposalAfterSubmit: () => {},
  showNewProposalUX: false,
};

export default SubmitToEmployer;
